module.exports = __webpack_public_path__ + "static/media/calendarDarkMode.8fb2ada2.svg";